export const copyToClipboard = (str) => {
  if (!navigator.clipboard) {
    return fallback(str);
  }

  return navigator.clipboard.writeText(str);
};

const fallback = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  var success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {}

  document.body.removeChild(el);
  return success ? Promise.resolve() : Promise.reject();
};
